<template>
    <section>
	    <section class="order-main">
	        <div class="content">
	            <div class="order-filter mgtop25">
	                <ul class="order-nav">
	                    <li :class="type=='Untreated'?'nav-item active':'nav-item'" @click="type='Untreated';initData(1);">Unprocessed Booking(s) <span class="count">（{{total||'0'}}）</span></li>
	                    <li :class="type=='New'?'nav-item active':'nav-item'"  @click="type='New';initData(1);">Today's New Booking(s) <span class="count">（{{totalNew||'0'}}）</span></li>
	                    <li :class="type=='TodayCheckIn'?'nav-item active':'nav-item'"  @click="type='TodayCheckIn';initData(1);">Today's Arrival <span class="count">（{{totalToday||'0'}}）</span></li>
	                    <!-- <li :class="type=='totalAll'?'nav-item active':'nav-item'"  @click="type='totalAll'">所有订单 <span class="count">{{totalAll}}</span></li> -->
	                    <li :class="type=='allOrder'?'nav-item active':'nav-item'" @click="type='allOrder'">All Bookings<span class="count">（{{totalAll||'0'}}）</span></li>
                      <li v-if="type!='allOrder'" class="upDate" @click="initData(1);">Refresh</li>
	                    <!-- <li class="nav-item">包房名单</li> -->
	                </ul>
	                <div class="filter-form" v-if="type=='allOrder'">
	                    <div class="filter-box">
	                        <div class="filter-item">
	                            <label class="item-title">Date Type：</label>
	                            <select class="item-input" v-model="DateType">
	                            	<option value="1">Booking Date</option>
	                            	<option value="2">Arrival Date</option>
	                            </select>
	                            <!-- <input class="item-input" type="text" v-model="DateType" /> -->
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">Guest Name：</label>
	                            <input class="item-input" type="text" v-model="CustName" />
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">Status：</label>
	     	                    <select class="item-input" v-model="OrderStatus">
	     	                    	<option value="">All</option>
	                            	<option value="0">Unread</option>
	                            	<option value="1">Read</option>
	                            	<option value="2">Accepted</option>
	                            	<option value="3">Rejected</option>
	                            </select>
	                        </div>
	                    </div>
	                    <div class="filter-box">
	                        <div class="filter-item">
	                            <label class="item-title">Period：</label>
	                            <div class="date-input ">
	                                <div class="date-box " @click="calendar.show=true">
	                                    <input class="item-date" type="text" v-model="DateFrom"  />
	                                </div>
	                                 <calendar v-if="calendar.show" :zero="calendar.zero" :lunar="calendar.lunar" :value="calendar.value" :begin="calendar.begin"  @select="calendar.select"></calendar>


	                                <div class="date-box"  @click="calendar2.show=true">
	                                    <input class="item-date" id="dateEnd21"  type="text" v-model="DateTo"/>
	                                </div>
	                            	<calendar style="margin-left:133px" v-if="calendar2.show" :zero="calendar2.zero" :lunar="calendar2.lunar" :value="calendar2.value" :begin="calendar2.begin"  @select="calendar2.select"></calendar>
	                            </div>
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">Conf. No.：</label>
	                            <input class="item-input" type="text" v-model="ConfirmNO"  />
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">Booking Type：</label>
	                            <select class="item-input" v-model="OrderType">
	                            	<option value="">All</option>
	                            	<option value="0">New Booking</option>
	                            	<option value="1">Amend Booking</option>
	                            	<option value="2">Canceled Booking</option>
	                            	<option value="3">Invalid Booking</option>
	                            </select>

	                        </div>
	                    </div>
	                    <div class="filter-box">
	                        <div class="filter-item">
	                            <label class="item-title">Booking No.：</label>
	                            <input class="item-input" type="text" v-model="OrderNO" />
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">Operator：</label>
	                            <input class="item-input" type="text" v-model="Oper" />
	                        </div>
	                        <div class="filter-item">
	                            <label class="item-title">Property Name：</label>
	                            <input class="item-input" type="text" v-model="HotelName" />
	                        </div>
	                    </div>
	                </div>
	                <div class="clear"></div>
	                <div class="search-btn" v-if="type=='allOrder'" @click="postData(1)">search</div>
	            </div>
	        </div>
	    </section>
	    <section class="order-content">
	        <div class="content">
	            <table class="order-table" cellspacing="0">
	                <thead>
	                    <tr>
	                        <td width="12%">Booking No.</td>
	                        <td width="6%">Type</td>
	                        <td width="6%">Status</td>
	                        <td width="17%">Property Name<br>Room Type</td>
	                        <td width="10%">Guest Name</td>
	                        <td width="10%">Arrival Date<br>Departure Date</td>
	                        <td width="7%">Room Number(s)</td>
                          <td width="7%">Total Room Nights</td>
													<td width="8%">Conf. No.</td>
	                        <td width="8%">Create Date</td>
	                        <td width="4%">Operator</td>
	                        <td width="4%">Log</td>
	                    </tr>
	                </thead>
	                <tbody>
	                	<tr v-for="item in list " >
	                		<td>
	                			<span class="order-new-icon swing" v-if="item.OrderStatesId==0" ></span>
	                			{{item.PurchaseOrderId}}<br>Prepay
	                		</td>
	                		<td>
	                			<span v-if="item.OrderTypeId==0" style="color:#ff3856">{{item.OrderType=='新单'?'New':item.OrderType=='变更单'?'Amend':item.OrderType=='取消单'?'Cancel':item.OrderType=='无效单'?'Invalid':''}}</span>
	                			<span v-if="item.OrderTypeId!=0">{{item.OrderType=='新单'?'New':item.OrderType=='变更单'?'Amend':item.OrderType=='取消单'?'Cancel':item.OrderType=='无效单'?'Invalid':''}}</span>
	                		</td>
	                		<td>
	                			<span v-if="item.OrderStatesId==0" style="color:#999999"> {{item.OrderStates=='未读'?'Unread':item.OrderStates=='已读未处理'?'Read':item.OrderStates=='接受'?'Accept':item.OrderStates=='拒绝'?'Refuse':''}}</span>
	                			<span v-if="item.OrderStatesId!=0" > {{item.OrderStates=='未读'?'Unread':item.OrderStates=='已读未处理'?'Read':item.OrderStates=='接受'?'Accept':item.OrderStates=='拒绝'?'Refuse':''}}</span>
	                		</td>
	                		<td>{{item.EnHotelName}}<br>{{item.EnRoomName}}</td>
	                		<td width="10%">{{item.GuestName}}</td>
	                		<td>{{item.CheckIn}}<br>{{item.CheckOut}}</td>
	                		<td>{{item.RoomNum}}</td>
                      <td>{{getDaysSize(item.CheckIn,item.CheckOut)*item.RoomNum}}</td>
											<td>{{item.ConfirmNo||'none'}}</td>
	                		<td>{{item.CreatTime.split(" ")[0]}}<br>{{item.CreatTime.split(" ")[1]}}</td>
	                	    <td><a class="check" @click="toOrderEdit(item)">view</a></td>
	                        <td><a @click="orderView(item)">log</a></td>
	                	</tr>
										<tr v-if="!list||list.length<1" >
											<td colspan="11" class="textCenter">No relevant data...</td>
										</tr>
	                </tbody>
	            </table>
	            <div class="paging-list" v-if="list&&list.length>0">
								<paginate
										:page-count="pageCount"
										:page-range="2"
										:margin-pages="1"
										:force-page="page"
										:click-handler="toGetData"
										:prev-text="'< last page'"
										:next-text="'next page >'"
										:container-class="'pagination'"
										:page-class="'page-item'">
								</paginate>
	              <span class="total-page">Total {{pageCount}} page</span>
	              <div class="clear"></div>
	            </div>
	        </div>
	    </section>
	    <section class="section-footer">
	        <div class="content">
	            <p>Booking and after-sales:（020-2214 6801） Domestic Products:（0755-82365588-1） Overseas Products:（0755-82365588-3）</p>
              <p>H.K. Products:（0755-82365588-2） Macau Products:（0756-8281308）</p>
	            <p>Copyright2013-2017,cnbooking.net.All rights reserved. <a href="https://beian.miit.gov.cn/">粤ICP备09018804号</a>  <a href="https://beian.mps.gov.cn/#/query/webSearch"> <img style="vertical-align: sub;" src="./../../assets/images/element.png" alt=""> 粤公网安备 44030302000401号</a></p>
	        </div>
	    </section>
	    <OrderView :vdata="orderViewData" ></OrderView>
        <div class="calendar-dialog" v-if="calendar.show">
            <div class="calendar-dialog-body">

            </div>
        </div>
    </section>
</template>

<script>
import Paginate from "vuejs-paginate";
import OrderView from "./OrderView.vue";
import Calendar from "./../../common/calendar/calendar.vue"; //日期选择器
export default {
  name: "order",
  components: {
    Paginate,
    OrderView,
    Calendar
  },
  data() {
    return {
      // hotelName: this.dao.get("HotelName"),
      list: [],
      type: "Untreated",
      page: 0,
      pageSize: 10,
      pageCount: 1,
      total: 0,
      totalNew: 0,
      totalToday: 0,
      totalAll: 0,
      orderViewData: {},
      DateType: 1,
      DateFrom: this.getDate(-90),
      DateTo: this.getDate(0),
      OrderNO: "",
      CustName: "",
      ConfirmNO: "",
      Oper: "",
      OrderStatus: "",
      OrderType: "",
      HotelName: "",
      calendar: {
        display: "",
        show: false,
        zero: true,
        begin:'', //默认日期
        value: this.getDate(-90).split("-"),
        lunar: false, //显示农历
        select: value => {
          if (!value) {
            this.calendar.show = false;
            return;
          }
          this.DateFrom = value.join("-");

          this.calendar.value = value;
          this.calendar2.begin = value;

          this.calendar2.value = value;
          this.DateTo = "";

          this.calendar2.show = true;

          this.calendar.show = false;
          var end = document.getElementById("dateEnd21");
          end.focus();
        }
      },
      calendar2: {
        display: "",
        show: false,
        zero: true,
        begin:'', //默认日期
        value: this.getDate(0).split("-"),
        lunar: false, //显示农历
        select: value => {
          if (!value) {
            this.calendar2.show = false;
            return;
          }
          this.DateTo = value.join("-");

          this.calendar2.value = value;
          this.calendar2.show = false;
          // this.calendar.display=value.join("-");
        }
      }
    };
  },
  watch: {
    type(val) {
      if (val == "allOrder") {
        this.postData(1);
      } else {
        // this.initData(1);
      }
    }
  },
  methods: {
    toGetData(page) {
      if (this.type == "allOrder") {
        this.postData(page);
      } else {
        this.initData(page);
      }
    },
    //初始化数据，page为页码
    initData(page) {
      var that = this;
      that.page = page - 1;
      var params = {
        type: that.type,
        page: page,
        pageSize: that.pageSize
      };
      that
        .getRequest({
          url: that.Api.getOrderList,
          params: params
        })
        .then(res => {
          that.list = res.Result;
          if (that.type == "Untreated") {
            that.total = res.Total;
          } else if (that.type == "New") {
            that.totalNew = res.Total;
          } else if (that.type == "totalAll") {
            that.totalAll = res.Total;
          } else {
            that.totalToday = res.Total;
          }
          that.pageCount = Math.ceil(res.Total / 10);
        });
    },
    //初始化数据，page为页码
    postData(page) {
      var that = this;
      that.page = page - 1;
      var params = {
        page: page,
        DateType: that.DateType,
        DateFrom: that.DateFrom.split("-").join("/"),
        DateTo: that.DateTo.split("-").join("/"),
        OrderNO: that.OrderNO,
        CustName: that.CustName,
        ConfirmNO: that.ConfirmNO,
        Oper: that.Oper,
        OrderStatus: that.OrderStatus,
        OrderType: that.OrderType,
        HotelName: that.HotelName
      };
      that
        .postRequest({
          url: that.Api.getOrderList,
          params: params
        })
        .then(res => {
          that.list = res.Result;
          if (that.type == "Untreated") {
            that.total = res.Total;
          } else if (that.type == "New") {
            that.totalNew = res.Total;
          } else if (that.type == "allOrder") {
            that.totalAll = res.Total;
          } else {
            that.totalToday = res.Total;
          }
          that.pageCount = Math.ceil(res.Total / 10);
        });
    },
    orderView(item) {
      this.orderViewData = item;
      this.$nextTick(function() {
        this.$set(item, "isShow", item.isShow ? false : true);
      });
    },
    toOrderEdit(item) {
      this.dao.set("ebID", item.EB_Id);
      this.dao.set("VerCol", item.VerCol);
      this.$router.push("/orderEdit");
    }
  },
  mounted() {
    this.initData(1);
    // 当页面可见性发生变化时，如果当前路由为 '/order' 则更新页面
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible" && this.$route.path === "/order") {
        if (this.type == "allOrder") {
          this.postData(1);
        } else {
          this.initData(1);
        }
      }
    });
  },
  activated() {
    if (this.type == "allOrder") {
      this.postData(this.page + 1);
    } else {
      this.initData(this.page + 1);
    }
  }
};
</script>
<style scoped>
.upDate{
    float: right;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin-right: 10px;
    cursor: pointer;
    color: #fff;
    background: #4584f5;
}
</style>





// WEBPACK FOOTER //
// src/components/order/Order.vue